export const GOV_STAGING_ENVIRONMENT = 'govgecko-staging'
export const GOV_PROD_ENVIRONMENT = 'govgecko-prod'
export const ADNOC_STAGING_ENVIRONMENT = 'adnoc-staging'
